import React, { useMemo, useState } from 'react'
import withSlideUpModal from '../../utils/hoc/withSlideUpModalComponent'
import { SocialAccount } from '../../types/influencer/influencerTypes'
import { toast } from 'react-toastify'

const CampaignApplicationNegotiation: React.FC<{
    isActive: boolean,
    apply: (languageId?: string, answers?: Record<string, string | number>, quotedOffer?: string | number) => void,
    status: string,
    socialAccount: SocialAccount,
    gigAmount: number,
    languageId?: string,
    answers?: Record<string, string | number>
}> = ({ apply, status, socialAccount, gigAmount, languageId, answers }) => {
    const [amount, setAmount] = useState<string>(gigAmount > 0 ? String(gigAmount) : '');

    const amountValue = useMemo(() => Number(amount), [amount]);
    const isValidAmount = useMemo(() => amount !== '' && amountValue > 0, [amount, amountValue]);

    const applyCampaign = () => {
        if (!isValidAmount) {
            toast.error('Please enter a valid amount');
            return;
        }
        apply(languageId, answers, amountValue);
    }

    return (
        <div className='campaign-apply-confirmation scrollable-modal-body p-0'>

            <div className="d-flex flex-column gap-2 p-3">
                <div>
                    <div className="form-group gap-2 d-flex flex-column mb-3">
                        <div className="d-flex gap-2">
                            <img src={(socialAccount.profile_picture_url ?? '').split("=")[0]} alt="" className='rounded-sm' width={50} height={50} />
                            <div className="d-flex flex-column">
                                <label htmlFor="">Applying using</label>
                                <span className='text-dark fs-16 fw-500'>{socialAccount.handle}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column gap-3">
                    <span className='text-dark fs-14 fw-400'>Think your content is worth more? Tell the brand your preferred payout.</span>
                    <div className="d-flex flex-column gap-2">
                        <label htmlFor="quoted-offer-amount" className='text-dark fs-12 fw-400 m-0'>ENTER YOUR AMOUNT</label>
                        <input
                            id="quoted-offer-amount"
                            className='campaign-negotiation-amount-input'
                            type="text"
                            inputMode="numeric"
                            value={amount}
                            placeholder={`Ex. ₹${(Number(gigAmount) + 100).toLocaleString('en-IN')}`}
                            onChange={(event) => setAmount(event.target.value.replace(/\D/g, ''))}
                        />
                    </div>
                </div>

            </div>

            <div className="campaign-apply-ig-connect-benefit-actions scrollable-modal-footer">
                <div className='px-3'>


                    <div className={`campaign-apply-disclaimer mb-2`}>
                        <span className="fw-bold">Disclaimer: </span>
                        <span>Application selection is decided by brand.</span>
                    </div>
                    <button onClick={applyCampaign} disabled={status === 'PENDING' || !isValidAmount} className="btn btn-primary w-100">{status === 'PENDING' ? 'Applying...' : 'Apply'}</button>
                </div>
            </div>

        </div>
    )
}

export default withSlideUpModal(CampaignApplicationNegotiation, "Make an Offer", true)
